<template>
  <div class="goods-item">
    <div class="left-con">
      <van-checkbox
          v-if="!cartEditState"
          v-model="skuIdSelected"
          :icon-size="15"
          checked-color="#f74646"
          @click="goodsClick"
          @change="checkGoods"
      />
      <van-checkbox
          v-if="cartEditState"
          v-model="editSkuIdSelected"
          :icon-size="15"
          checked-color="#f74646"
          @click="editCheckGoods"
      />
    </div>
    <div class="goods-con" :class="{'no-stock': (itemDataMapSkusStockStockStateId===34)}">
      <div class="img-com" @click="goJdGoodsDetail">
        <img class="img" :src="'http://img13.360buyimg.com/n2/' + itemData.mapProductDetail.coverImage" alt="">
        <div class="no-stock-img" v-if="itemDataMapSkusStockStockStateId===34 || itemDataMapSkusStockStockStateId===36"></div>
      </div>
      <div class="goods-info">
        <div class="goods-title" @click="goJdGoodsDetail">{{ itemData.mapProductDetail.title }}</div>
        <div class="info-bottom">
          <div class="price-con" @click="goJdGoodsDetail">
            <span class="now-price">￥{{ itemData.mapPrice.sellPrice.toFixed(2) }}</span>
            <span class="old-price"><s>原价:￥{{ itemData.mapPrice.displayOriginalPrice.toFixed(2) }}</s></span>
          </div>
          <div class="stepper-con">
            <van-stepper
                name="buyNum"
                v-model="buyNum"
                integer
                min="1"
                max="200"
                input-width="38"
                button-size="18"
                :disabled="!buyNumCanChange || false"
                :disable-input="!buyNumCanChange || false"
                :async-change="true"
                @plus="buyNumClick"
                @minus="buyNumClick"
                @blur="buyNumClickBlur"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getJdGoodsDetail } from '@/api/mall/mallGoods'
import { getShopSkuPrice } from '@/api/mall/mallJD'
export default {
  components: {
  },
  props: {
    itemData2: {
      required: true,
    },
    shopId: {
      required: true
    },
    shopIndexKey: {
      required: true
    },
    shopEditClick: {
      required: false
    },
  },
  data(){
    return {
      itemData: {
        mapSkusStock: {
          stockStateId: 33
        }
      },
      itemDataMapSkusStockStockStateId: '',
      buyNum: 1,
      buyNumCanChange: true,//是否点击时暂时禁用
      skuIdSelected: false,
      isGoodsClick: false,
      editSkuIdSelected: false,
    }
  },
  computed:{
    ...mapGetters([
      'cartList',//购物车列表
      'cartEditState',//是否编辑状态
    ])
  },
  watch: {
    itemData2: {
      handler(newData, oldData) {
        // console.log( 'newData',  newData )
        this.itemData = newData
        this.buyNum = newData.productCount
        this.buyNumCanChange=true
        this.skuIdSelected = newData.skuIdSelected
        this.editSkuIdSelected = newData.editSkuIdSelected
        if(newData.mapSkusStock){
          this.itemDataMapSkusStockStockStateId = newData.mapSkusStock.stockStateId || ''
        }
      },
      deep:true,
      immediate: true
    },
    shopEditClick: {
      handler(newData, oldData) {
        this.editSkuIdSelected = this.itemData.editSkuIdSelected
      },
      deep:true,
      immediate: true
    },
    cartEditState(val){
      if(val){
        this.editSkuIdSelected = false
      }
    }
  },
  created(){

  },
  methods: {
    goodsClick(){
      this.isGoodsClick = true
    },
    //处理商品勾选状态
    checkGoods(val){
      if(this.isGoodsClick){
        let count = 0
        let list = this.cartList[this.shopIndexKey].shopItems
        let shopItems = list.map(goods=>{
          if(this.itemData.productCode===goods.productCode){
            if(val){count++}else {count--}
            return {skuId: goods.productCode, skuIdSelected: val}
          }else {
            if(goods.skuIdSelected){count++}
            return {skuId: goods.productCode, skuIdSelected: goods.skuIdSelected}
          }
        });
        count = count<0 ? 0 : count;
        let arr = [{shopId: this.shopId, shopSelected: (count===list.length), shopItems}]
        this.$store.dispatch('sg/changeBuyCartSelect', arr)
        this.isGoodsClick = false
      }
    },
    editCheckGoods(){
      this.editSkuIdSelected = !this.editSkuIdSelected
      this.$emit('changeEditSkuSelect', {skuId: this.itemData.productCode, editSkuIdSelected: this.editSkuIdSelected})
    },

    buyNumClick(){
      if(this.buyNumCanChange){
        this.buyNumCanChange = false
        this.buyNumChange(this.buyNum)
      }
    },
    buyNumClickBlur(){
      if(this.buyNumCanChange){
        if(typeof this.buyNum === 'string'){
          this.buyNum -= 0
        }
        if(this.buyNum>200){
          this.buyNum=200
        }else if(this.buyNum<1){
          this.buyNum=1
        }
        this.buyNumCanChange = false
        this.buyNumChange(this.buyNum)
      }
    },
    buyNumChange(num){
      if(typeof num === 'number'){
        this.$store.dispatch('sg/updateCount', {cartId: this.itemData.cartId, productCount: num})
      }
    },

    goJdGoodsDetail(){
      if(this.cartEditState){return false}
      this.$router.push({name: 'jdGoodsDetail', query: {shopId: this.shopId, goodsId: this.itemData.goodsId} })
    }
  }
}
</script>

<style lang="less" scoped>
.goods-item{
  display: flex;font-size: 14px;height: 115px;
  .left-con{
    display: inline-flex;justify-content: center;align-items: center;
    width: 39px;height: 100%;
  }
  .goods-con{
    display: flex;flex: 1;
    .img-com{
      width: 89px;height: 100%;position: relative;
      display: inline-flex;justify-content: center;align-items: center;
      .img{width: 85px;height: 85px;}
    }
    .goods-info{
      flex: 1;display: inline-flex;flex-direction: column;
      justify-content: space-between;
      border-bottom: 1px solid #edecec;
      padding: 15px 12px 15px 0;
      .goods-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        color: rgba(43,43,43,1);
      }
      .info-bottom{
        display: flex;
        .price-con{
          flex: 1;
          .now-price{color: #f74d4d;padding-right: 10px;}
          .old-price{color: #999;font-size: 10px;}
        }
        .stepper-con{

        }
      }
    }
    &.no-stock{
      .no-stock-img{
        position: absolute;width: 100%;height: 100%;z-index: 1;
        background: rgba(255,255,255,.5) url("../../../../../assets/my/shoppingCart/no-stock-img.png") no-repeat 50% 50%;
        background-size: 60px 60px;
      }
      .goods-info{
        .goods-title{color: rgba(43,43,43,.5);}
        .info-bottom{
          .price-con{
            .now-price{color: rgba(247,77,77,.5);}
            .old-price{color: rgba(153,153,153,.5);}
          }
        }
      }
    }
  }


}
</style>